import React, { useState, useEffect } from "react";
import { Loader } from "./Loader";
import { toast } from "react-toastify";
import { ButtonConfirm } from "./Buttons/ButtonConfirm";
import { useAppContext } from "../../AppProvider";
import { faDownload } from "@awesome.me/kit-c1b85ff10f/icons/classic/light";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import API from "../../helpers/API";

const api = new API();

const ZPLViewer = ({ url, reference, ddtEnabled = true, shipmentId }) => {
  const { dictionary } = useAppContext();
  const [pdfBlob, setPdfBlob] = useState(null);
  const [pdfBlobUrl, setPdfBlobUrl] = useState("");

  const generateLabel = async (zplCode) => {
    if (ddtEnabled) {
      zplCode = zplCode.replaceAll(
        "^PQ1,0,1,Y^XZ",
        `^FO330,690^BQN,2,5
        ^FDLA,https://${api.getURL()}/shipments/ddt/${shipmentId}^FS 

        ^CFA,18
        ^FO30,830^FB800,1,0,C,0
        ^FD eDDT - Documento di trasporto elettronico ^FS

        ; --- Logo centrato sotto il QR Code ---
        ^FO340,1060^FB800,1,0,C,0   ; posiziona orizzontalmente centrato (X=280 circa, Y=950)
        ^GFA,702,702,18,J0E,I03F8,I0FBE,003E0F8,00F80318,01E0013C,07CI07C,1FJ038,1CJ01L038070EJ07FF,18Q03C070EJ07FFC,:1EQ07E070EJ0781E,0F8J0F8J07E070EJ0781E,07CI03FCJ0EF070E07F8781E0FE1C1E,01FI079CJ0E7070E0FFC781E3FF9E3C,007C01F0CJ0E7070E1FFC7FFC3FF8F78,001E07C0CI01C3870E1C1C7FFC783C7F,I040F00CI01C3870E001C7FFE781C3F,J03E00CI03FFC70E0FFC780F783C3E,J07801CI03FFC70E1FFC780F783C3E,J07001CI03FFC70E1C1C780F781C3F,CI0E001CI0781E70E1C1C780F783C7F,CI06001CI0700E7EFDC3C7FFE3FF8F38,CI06001CI0F00E7EFDFFC7FFE3FF9E3C,CI0E001CI0F00F3E7CFEE3FF81FF3C1E,CI0E001C,::EI0E001C,7I0E0038,7C00E0078,1F00E11FJ042I021C71049C02018614,07C0E3CCJ022I041009029201024908,01E0E7EK022I051C09059205024808,00F8E7EK09208011451449204024114,003FC7E,I0FC3C,I0301,,^FS
        
        ^PQ1,0,1,Y
        ^XZ`
      );
    }
    try {
      const response = await fetch(
        `https://api.labelary.com/v1/printers/8dpmm/labels/4x6/`,
        {
          method: "POST",
          body: zplCode,
          headers: {
            "Content-Type": "application/x-www-form-urlencoded",
            accept: "application/pdf",
          },
        }
      );

      if (!response.ok) {
        toast.error(`Errore durante la conversione del file ZPL`, {
          position: toast.POSITION.TOP_CENTER,
        });
        return;
      }

      const blob = await response.blob();
      setPdfBlob(blob);

      // Creiamo un URL per il blob e lo memorizziamo
      const url = URL.createObjectURL(blob);
      setPdfBlobUrl(url);
    } catch (error) {
      toast.error(`Errore durante la conversione del file ZPL`, {
        position: toast.POSITION.TOP_CENTER,
      });
    }
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetch(url);
        if (!response.ok) {
          toast.error(`Errore durante il recupero del file`, {
            position: toast.POSITION.TOP_CENTER,
          });
          return;
        }
        const content = await response.text();
        generateLabel(content);
      } catch (error) {
        toast.error(`Errore durante il recupero del file`, {
          position: toast.POSITION.TOP_CENTER,
        });
      }
    };

    if (url) {
      fetchData();
    }
  }, [url, ddtEnabled]);

  const handleDownload = () => {
    if (pdfBlob) {
      const a = document.createElement("a");
      a.href = pdfBlobUrl;
      a.download = reference || "download"; // Imposta il nome del file
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
    }
  };

  return (
    <div>
      {pdfBlobUrl ? (
        <div className="text-center">
          {/* Embed PDF with forced download */}
          <iframe
            src={pdfBlobUrl}
            style={{ width: "100%", height: "500px" }}
            title="Anteprima PDF"
          ></iframe>

          <ButtonConfirm icon={false} className="mt-3" onClick={handleDownload}>
            <FontAwesomeIcon icon={faDownload} /> {dictionary.actions.print} PDF
          </ButtonConfirm>
        </div>
      ) : (
        <Loader show={true} />
      )}
    </div>
  );
};

export default ZPLViewer;
